// biome-ignore lint/correctness/noUnusedImports: <turned off auction for now>
import { amazonConfig } from "@/config/reach/alloutgaming/article/amazonConfig";
import bartConfig from "@/config/reach/alloutgaming/common/bartConfig.json";
import auctionConfig from "@/config/reach/common/auction.json";
import consentConfig from "@/config/reach/common/consent.json";
import { carouselAdSizesGPT } from "@/config/reach/common/gpt/carouselAdSizes";
import gptConfig from "@/config/reach/common/gpt/gptConfig.json";
import loginRadiusConfig from "@/config/reach/common/loginradius.json";
import articleAdSizesMagnite from "@/config/reach/common/magnite/articleAdSizes.json";
import magniteBidderSettings from "@/config/reach/common/magnite/bidderSettings.json";
import carouselAdSizesMagnite from "@/config/reach/common/magnite/carouselAdSizes.json";
import magniteConfig from "@/config/reach/common/magnite/magniteConfig.json";
import pbjsConfig from "@/config/reach/common/pbjsConfig.json";
import bidderSettings from "@/config/reach/common/prebid/bidderSettings.json";
import carouselAdUnits from "@/config/reach/common/prebid/catch-all/carouselAdUnits.json";
import displayAdUnits from "@/config/reach/common/prebid/catch-all/displayAdUnits.json";
import outstreamAdUnits from "@/config/reach/common/prebid/catch-all/outstreamAdUnits.json";
import videoAdUnits from "@/config/reach/common/prebid/catch-all/videoAdUnits.json";
import consentManagement from "@/config/reach/common/prebid/consentManagement.json";
import currency from "@/config/reach/common/prebid/currency.json";
import mediaTypePriceGranularity from "@/config/reach/common/prebid/mediaTypePriceGranularity.json";
import ozone from "@/config/reach/common/prebid/ozone.json";
import paapiForGpt from "@/config/reach/common/prebid/paapiForGpt.json";
import userSync from "@/config/reach/common/prebid/userSync.json";
// biome-ignore lint/correctness/noUnusedImports: <turned off auction for now>
import { AmazonTAM } from "@/module/AmazonTAM";
import { AuctionController } from "@/module/AuctionController";
import { BART } from "@/module/BART";
import { Blockthrough } from "@/module/Blockthrough";
import { Consent } from "@/module/Consent";
import { GPT } from "@/module/GPT";
import { LiveRamp } from "@/module/LiveRamp";
import { LoginRadius } from "@/module/LoginRadius";
// biome-ignore lint/correctness/noUnusedImports: <turned off auction for now>
import { MagniteDemandManager } from "@/module/MagniteDemandManager";
import { Ozone } from "@/module/Ozone";
// biome-ignore lint/correctness/noUnusedImports: <turned off auction for now>
import { Prebid } from "@/module/Prebid";
import { SequenceController } from "@/module/SequenceController";
import { SlotDiscovery } from "@/module/SlotDiscovery";
import { AdUnitPath } from "@/module/reach/AdUnitPath";
import type { GPTModuleConfig, MagniteModuleConfig, PrebidModuleConfig, } from "@/ts/module";
import type { PrebidConfig } from "@/ts/prebid/types";
import { initModulesAndCommandQueue } from "@/utils/initialize";
const adSizesMagnite = {
    ...articleAdSizesMagnite.adSizesMagnite,
    ...carouselAdSizesMagnite.adSizesMagnite,
};
// biome-ignore lint/correctness/noUnusedVariables: <turned off auction for now>
const magniteModuleConfig: MagniteModuleConfig = {
    ...magniteConfig,
    adSizesMagnite,
    pbjsConfig,
    bidderSettings: magniteBidderSettings,
};
const prebidConfig: PrebidConfig = {
    ...consentManagement,
    ...currency,
    ...mediaTypePriceGranularity,
    ...ozone,
    ...userSync,
    ...pbjsConfig,
    ...paapiForGpt,
};
// biome-ignore lint/correctness/noUnusedVariables: <turned off auction for now>
const prebidModuleConfig: PrebidModuleConfig = {
    prebidConfig,
    carouselAdUnits,
    displayAdUnits,
    videoAdUnits,
    outstreamAdUnits,
    bidderSettings,
};
const gptModuleConfig: GPTModuleConfig = {
    ...carouselAdSizesGPT,
    ...gptConfig,
};
export const initApp = async () => {
    const modules = [
        // first, modules that others might subscribe to
        new Consent(consentConfig),
        new SlotDiscovery(),
        new GPT(gptModuleConfig),
        // new AmazonTAM(amazonConfig),
        // new MagniteDemandManager(magniteModuleConfig),
        // new Prebid(prebidModuleConfig),
        new AuctionController(auctionConfig),
        // modules that don't use subscriptions
        new BART(bartConfig),
        new LiveRamp(),
        new LoginRadius(loginRadiusConfig),
        new AdUnitPath(),
        new Ozone(),
        new Blockthrough(),
        // last, modules that subscribe to others
        new SequenceController(),
    ];
    await initModulesAndCommandQueue(modules);
};
initApp();
